export default "__VITE_ASSET__DSFPZeOh__"